import React from 'react'
import Stack from '../Primitives/Stack'
import Pad from './Pad'
import Beat from './Beat'

export default function Coral(props) {
  let isPlaying = props.isPlaying,
      setIsPlaying = props.setIsPlaying,
      handleClick = props.handleClick,
      handleDrag = props.handleDrag,
      tuningArray = props.tuningArray,
      sequencer = props.sequencer,
      playingBeatIndex = props.playingBeatIndex,
      setPlayingBeatIndex = props.setPlayingBeatIndex,
      editingBeatIndex = props.editingBeatIndex,
      setEditingBeatIndex = props.setEditingBeatIndex,
      editingNotes = sequencer[editingBeatIndex] ? sequencer[editingBeatIndex][1] : undefined,
      octaveShift = props.octaveShift

  tuningArray = props.tuningArray.map(note => {
    // Shift up those note values. We'll use this array later to build the pad deal.
    note = note.split("")
    note[note.length - 1] = parseInt(note[note.length - 1], 10) + parseInt(octaveShift, 10)
    note = note.join("")

    return note
  })

  return (
    <main className={props.isLoaded ? "" : "loading"} onTouchMove={e => handleDrag(e)}>
      <Stack spacing="huge">
        <Stack id="Sequencer" orientation="horizontal" spacing="medium">
          {sequencer.map((beat, index) => {
            return <Beat 
                      key={index} 
                      index={index} 
                      tuningArray={tuningArray} 
                      notesArray={beat}
                      playingBeatIndex={playingBeatIndex}
                      editingIndex={editingBeatIndex}
                      setEditingIndex={setEditingBeatIndex}
                    />
          })}
        </Stack>
        <div id="Pads">
          {tuningArray.map((note, index) => {
            return <Pad key={index} handleClick={handleClick} editingNotes={editingNotes} note={note}>{index + 1}{/* <span className="note-label">({note})</span> */}</Pad>
          })}
        </div>
        {/* <Stack className="controls" orientation="horizontal" spacing="small" center="true"> */}
          <div id="Control" className={isPlaying ? "playing" : "stopped"} title={isPlaying ? "Atmosphere On" : "Atmosphere Off"}>
            <span id="Symbol" 
              onClick={(() => {
                props.toneContext.start()
                setIsPlaying(!isPlaying)
                setPlayingBeatIndex(-1)
              })} 
            >
              <svg width="56" height="56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M42.76 28.358c-1.08 0-2.025-.252-2.838-.757a5.313 5.313 0 0 1-1.917-2.077c-.448-.88-.672-1.882-.672-3.006 0-1.124.233-2.11.697-2.957a5.36 5.36 0 0 1 1.942-2.028c.83-.489 1.767-.733 2.812-.733 1.892 0 3.31.66 4.256 1.98l-.747.708-.149.171-.124-.122a.436.436 0 0 0-.075-.318c-.05-.114-.174-.269-.373-.464a3.315 3.315 0 0 0-1.22-.684c-.448-.163-1.02-.245-1.717-.245-.714 0-1.386.188-2.016.562-.614.375-1.112.904-1.494 1.589-.365.684-.547 1.49-.547 2.419 0 .977.182 1.833.547 2.566.365.733.871 1.303 1.519 1.71.647.408 1.385.611 2.215.611 1.294 0 2.397-.505 3.31-1.515l.697.831c-1.112 1.173-2.48 1.76-4.107 1.76zm-29.146 11.2c1.079 0 2.024-.252 2.837-.757a5.313 5.313 0 0 0 1.917-2.077c.448-.88.672-1.882.672-3.006 0-1.124-.232-2.11-.697-2.957a5.36 5.36 0 0 0-1.941-2.028c-.83-.489-1.767-.733-2.813-.733-1.891 0-3.31.66-4.256 1.98l.747.708.15.171.124-.122a.436.436 0 0 1 .074-.318c.05-.114.175-.269.374-.464.348-.31.755-.538 1.22-.684.447-.163 1.02-.245 1.717-.245.713 0 1.385.188 2.016.562.614.375 1.111.904 1.493 1.589.365.684.547 1.49.547 2.419 0 .977-.182 1.833-.547 2.566-.365.733-.871 1.303-1.518 1.71-.647.408-1.386.611-2.215.611-1.295 0-2.398-.505-3.31-1.515l-.697.831c1.111 1.173 2.48 1.76 4.106 1.76z" fill="#FFB3CB"/><path fillRule="evenodd" clipRule="evenodd" d="M54.963 1.018H1.037v53.964h53.926V1.018zM0 0v56h56V0H0z" fill="#FFB3CB"/><path d="M1.545 25.088c-.182.205-.35.403-.508.594v1.688c.311-.434.743-.996 1.29-1.613 1.242-1.401 3.062-3.066 5.394-4.171 2.321-1.101 5.154-1.65 8.458-.824 3.314.828 7.15 3.05 11.441 7.585 4.382 4.629 8.382 6.988 11.945 7.878 3.572.893 6.655.296 9.165-.894 2.5-1.185 4.428-2.957 5.725-4.42.182-.204.35-.402.508-.593V28.63c-.311.434-.743.996-1.29 1.613-1.242 1.401-3.062 3.066-5.394 4.171-2.321 1.101-5.154 1.65-8.458.825-3.313-.828-7.15-3.051-11.441-7.586-4.382-4.629-8.382-6.988-11.945-7.878-3.572-.893-6.655-.296-9.165.894-2.5 1.185-4.428 2.957-5.725 4.42z" fill="#FFB3CB"/></svg>
            </span>
          </div>
        {/* </Stack> */}
      </Stack>
      </main>
  )
}
